export enum TipoOrigemDespesaGroupPay {
  NOTA_FISCAL = "NOTA_FISCAL",
  BOLETO = "BOLETO",
  MAIL_READER = "MAIL_READER",
}

export const getTipoSacadoFormatado = (origem: TipoOrigemDespesaGroupPay) => {
  switch (origem) {
    case TipoOrigemDespesaGroupPay.NOTA_FISCAL:
      return "Nota Fiscal";
    case TipoOrigemDespesaGroupPay.BOLETO:
      return "Boleto";
    case TipoOrigemDespesaGroupPay.MAIL_READER:
      return "E-mail";
    default:
      return "-";
  }
};
